import * as THREE from 'three';

const EARTH_RESOLUTION = HIGH_RES? 768:128; // 768 on the PC //128,256 on my computer

export class Earth{
    constructor(){
        /**
         * SphereGeometry
         * radius,
         * widthSegments,
         * heightSegments,
         * phiStart, specify horizontal starting angle. Default is 0.
         * phiLength, specify horizontal sweep angle size. Default is Math.PI * 2.
         * thetaStart, specify vertical starting angle. Default is 0.
         * thetaLength, specify vertical sweep angle size. Default is Math.PI.
         */
        console.log('EARTH_RESOLUTION :', EARTH_RESOLUTION);
        const textureLoader = new THREE.TextureLoader();
        const geometry = new THREE.SphereGeometry( 0.5, EARTH_RESOLUTION, EARTH_RESOLUTION );
        const material = new THREE.MeshPhongMaterial({
            map: textureLoader.load('assets/images/earth_2048.jpg'),
            normalMap: textureLoader.load('assets/images/normal_2048.jpg'),
            normalScale: new THREE.Vector2(0.15, -0.15),
            displacementMap: textureLoader.load('assets/images/earth_displacement_2048.jpg'),
            displacementScale: 0.005,
            specularMap: textureLoader.load('assets/images/specular_2048.jpg'),
            specular: new THREE.Color(0x0a0a0a),
            reflectivity: 0.3,
            shininess: 15
        });

        material.displacementMap.wrapS = THREE.RepeatWrapping;
        material.displacementMap.wrapT = THREE.RepeatWrapping;
        material.displacementMap.minFilter = THREE.NearestMipMapLinearFilter;
        // material.bumpMap = new THREE.TextureLoader().load('images/8k_normal.jpg');
        // material.bumpScale = 0.04;
        this.mesh = new THREE.Mesh(geometry, material);
        this.mesh.renderOrder = 10;
    }

    getMesh() {
        return this.mesh;
    }
}
